<template>
    <iframe style="width: 100%;height: 100%"
            class="mgt5"
            :id="'iframe_' + refnm"
            :src="getHwpCtrlAddr(refnm)"></iframe>
</template>

<script>
    /*import $ from 'jquery';*/

    export default {
        name: "hwp",
        props: [
            'refnm',
            'initializedCallbackFunc'
        ],
        data: function () {
            return {
                webHwpCtl:null,
                callbackFunc:{
                    initialized:null,
                    saveHwpContent:null,
                    saveHwpFormContent:null,
                    loadHwpContent:null,
                    remoteHwpOpen:null,
                    getHwpContent:null,
                    runAction:null,
                    getFieldList:null,
                    setFieldList:null,
                    insertSignImage:null,
                    deleteSignImage:null,
                    makeImageFile:null,
                }
            }
        },
        methods: {
            getHwpCtrlAddr : function(refnm){
                /*var url = this.$onbiLib.hostnames.hwp + '/webhwpctrl/ongw.html?refNm=' + refnm;*/
                var hancomJsUrl = '/js/works/hancom.js';
                var hostname = location.hostname;

                if(hostname.indexOf("localhost")>-1 ||
                   hostname.indexOf("192.168.")>-1){
                    hancomJsUrl = 'https://devi5gam.gulumma.net' + hancomJsUrl;
                    //hancomJsUrl = 'http://localhost:8080' + hancomJsUrl;
                    hostname = 'http://testhwp.bo6in.com';
                }else if(hostname.indexOf("devi5gam.gulumma.net")>-1 ||
                         hostname.indexOf("test.ma.bo6in.com")>-1 ||
                         hostname.indexOf("test.mb.bo6in.com")>-1){
                    hancomJsUrl = 'http://' + hostname + hancomJsUrl;
                    hostname = 'http://testhwp.bo6in.com';
                }else{
                    hancomJsUrl = location.protocol + '//i5gam.gulumma.net' + hancomJsUrl;
                    hostname = location.protocol + '//hwp.bo6in.com';
                }

                var url = hostname + '/webhwpctrl/ongw.html?refNm=' + refnm + '&hancomJsUrl=' + encodeURIComponent(hancomJsUrl);

                return url;
            },
            sendPostMessage: function(command,params,callbackFunc){
                this.callbackFunc[command] = null;
                if(callbackFunc != null) this.callbackFunc[command] = callbackFunc;

                var data = {
                    refNm : this.refnm,
                    command : command,
                    params : params
                };

                this.webHwpCtl.source.postMessage(JSON.parse(JSON.stringify(data)),"*");
            },
            postMessageReceiver : function(e){
                if(e.data.command=='initialized'){
                    this.webHwpCtl = e;
                    if(this.callbackFunc.initialized != null){
                        this.callbackFunc.initialized(this.sendPostMessage,this.webHwpCtl);
                    }
                }else{
                    if(this.callbackFunc[e.data.command] != null){
                        this.callbackFunc[e.data.command](e.data);
                    }
                }
            }
        },
        computed: {
        },
        created: function(){
            this.callbackFunc.initialized = this.initializedCallbackFunc;
        },
        mounted:function(){
            window.removeEventListener('message', this.postMessageReceiver);
            window.addEventListener("message", this.postMessageReceiver, false);
        },
        destroyed : function(){
        }
    }
</script>

<style scoped>

</style>
